import { render, staticRenderFns } from "./GiftCardList.vue?vue&type=template&id=b7b1889a&scoped=true&"
import script from "./GiftCardList.vue?vue&type=script&lang=js&"
export * from "./GiftCardList.vue?vue&type=script&lang=js&"
import style0 from "./GiftCardList.vue?vue&type=style&index=0&id=b7b1889a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b1889a",
  null
  
)

export default component.exports